import { observer } from "mobx-react-lite";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
// import { Button } from "react-bootstrap";
import { Button } from "semantic-ui-react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";
import Pagination from "react-bootstrap/Pagination";
import Footer from "../Footer";
import LoadingComponent from "../../app/layout/LoadingComponent";
import ModalFinancieroPago from "./Handlers/ModalFinancieroPago";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const apiURL = process.env.REACT_APP_API_URL;
let paginadorTotal: number;

const modTool = (p: any) => (
  <Tooltip id="button-tooltip" {...p}>
    Aplicar pago a código institucional
  </Tooltip>
);

const modVer = (p: any) => (
  <Tooltip id="button-tooltip" {...p}>
    Ver el detalle del código institucional
  </Tooltip>
);

export default observer(function FinancieroListaConvenios() {
  let items: any = [];
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [convenio, setConvenios] = useState([]);

  const [crops, setCrops] = useState({
    conv: '',
    mont: 0,
    idco: 0,
    entidad: 0
  });

  const {
    conv,
    mont,
    idco,
    entidad
  } = crops;

  function ropm(
    co: string,
    mo: number,
    id: number,
    enid: number
  ) {
    setCrops({
      ...crops,
      idco: id,
      mont: mo,
      conv: co,
      entidad: enid

    });
    setModalShow(true);
  }

  const handlePageClick = (numberPagina: number) => {
    setCurrentPage(numberPagina);
  };

  const [currentPage, setCurrentPage] = useState(1);
  let url = apiURL + `/CATConvenios/Financiero/${currentPage}/10`;

  useEffect(() => { listaConvenios(); }, [currentPage]);

  const listaConvenios = async () => {
    setLoading(true);
    const responseConvenio = await axios(url);
    const { data } = responseConvenio;
    paginadorTotal = data.totalPages;

    const convenios = data.records.map(
      (dataR: {
        id: number;
        monto: number;
        fecha: any;
        descuento: number;
        codigoInstitucional: string;
        sgtEntidad: any;
        estadoConvenio: number;
        pagoExoneracion: number;
        entidadid: number;
      }) => {

        let urlConv = url + "/" + dataR.id;

        return {
          id: dataR.id,
          fecha: dataR.fecha,
          monto: dataR.monto,
          descuento: dataR.descuento,
          convenio: dataR.codigoInstitucional,
          url: urlConv,
          entidad: dataR.sgtEntidad.entidad,
          entidadid: dataR.sgtEntidad.idEntidad,
          estado: dataR.estadoConvenio,
          pago: dataR.pagoExoneracion
        };
      }
    );
    setConvenios(convenios);
    setLoading(false);
  };

  for (
    let numberPagina: any = 1;
    numberPagina <= paginadorTotal;
    numberPagina++
  ) {
    items.push(
      <Pagination.Item
        key={numberPagina}
        active={currentPage === numberPagina}
        activeLabel={""}
        onClick={() => {
          handlePageClick(numberPagina);
        }}
      >
        {numberPagina}
      </Pagination.Item>
    );
  }

  const ConvenioItems = (dataR: {
    id: number;
    fecha: any;
    monto: number;
    descuento: number;
    convenio: string;
    url: any;
    entidad: any;
    estado: number;
    pago: number;
    entidadid: number;
  }) => {
    let montoConv = new Intl.NumberFormat("es-GT").format(dataR.monto);
    let descuentoB = dataR.descuento / 100;
    let descuentoT = dataR.monto - dataR.monto * descuentoB;
    let motoConDes = new Intl.NumberFormat("es-GT").format(descuentoT);

    const convURL = "/financieros/convenios/detalle/" + dataR.id;

    function montoLogic(obj: number) {
      if (obj <= 0) {
        return "Exoneracion Total";
      } else if (obj >= 1 && dataR.descuento == 0) {
        return "Q. " + montoConv + ".00";
      } else if (obj >= 1 && dataR.descuento >= 1) {
        return "Q. " + motoConDes + ".00";
      }
    }

    //console.log(dataR.estado)

    return (
      <li>
        <Container className="convenio-body-item">
          <div className="convenio-body-section conv-sect1">
            {dataR.convenio}
          </div>
          <div className="convenio-body-section conv-sect2">
            {dataR.entidad}
          </div>
          <div className="convenio-body-section conv-sect3">
            {calculoFechas(dataR.fecha)}
          </div>
          <div className="convenio-body-section conv-sect4">
            {montoLogic(dataR.monto)}
          </div>
          <div className="convenio-body-section conv-sect5 solicitud-body-sec-actions">

            <>

              {dataR.estado == 4 && dataR.pago == 0 ?

                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={modTool}
                >
                  <Button
                    className="circular-button edi-sol-but"
                    circular
                    color='twitter'
                    type="button"
                    icon={'check'}
                    onClick={() => ropm(
                      dataR.convenio,
                      dataR.monto,
                      dataR.id,
                      dataR.entidadid
                    )}
                  />

                </OverlayTrigger>

                :

                null

              }

              <Link to={convURL}>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={modVer}
                >
                  <Button
                    className="circular-button"
                    circular
                    color='facebook'
                    type="button"
                    icon={'ellipsis vertical'}
                  />
                </OverlayTrigger>

              </Link>

            </>

          </div>
        </Container>
      </li>
    );
  };

  return (
    <>
      <Container className="convenios-section convenios-financiero">
        <Container>
          <Row>
            <p className="exclusivo">Para uso exclusivo financiero</p>
          </Row>
          <Row>
            <Col className="buscar-convenio-area">
              <Form.Control placeholder="Buscar convenio" />
              <Button variant="primary">Buscar</Button>{" "}
            </Col>

            <Col className="crear-convenio-area"></Col>
          </Row>
        </Container>

        <Container className="convenio-head-list">
          <div className="convenio-head-section conv-sect1">
            Código Institucional
          </div>
          <div className="convenio-head-section conv-sect2">Entidad</div>
          <div className="convenio-head-section conv-sect3">Fecha</div>
          <div className="convenio-head-section conv-sect4">Monto</div>
          <div className="convenio-head-section conv-sect5">Acciones</div>
        </Container>

        <Container className="convenio-body-list">
          {loading ? (
            <LoadingComponent content="Cargando lista de códigos..." />
          ) : (
            <>
              <ul>
                {convenio.map(
                  (convenio: {
                    id: number;
                    fecha: any;
                    monto: number;
                    descuento: number;
                    convenio: string;
                    url: any;
                    entidad: any;
                    entidadid: number;
                    estado: number;
                    pago: number;
                  }) => (
                    <ConvenioItems {...convenio} />
                  )
                )}
              </ul>
            </>
          )}
        </Container>

        <Container className="pagination-convenios-area">
          <Pagination>{items}</Pagination>
        </Container>
      </Container>

      <Footer />

      <ModalFinancieroPago
        id={idco}
        key={idco}
        onHide={() => { setModalShow(false) }}
        show={modalShow}
        ctype={"CATConvenio"}
        conv={conv}
        monto={mont}
        entidadid={entidad}
      />

    </>
  );
});
